import { DesignProp, LayoutProp } from "../PropCategories";

export const alignItems = {
  prop: "style-attribute",
  name: "Align Items",
  nameI18n: "builder_ui.prop_type.styles.align_items",
  category: [DesignProp, LayoutProp],
  type: "select",
  defaultValue: "center",
  options: [
    {
      label: "Flex Start",
      labelI18n: "builder_ui.prop_type.styles.align_items_types.flex_start",
      value: "flex-start",
    },
    {
      label: "Center",
      labelI18n: "builder_ui.prop_type.styles.align_items_types.center",
      value: "center",
    },
    {
      label: "Flex End",
      labelI18n: "builder_ui.prop_type.styles.align_items_types.flex_end",
      value: "flex-end",
    },
    {
      label: "Stretch",
      labelI18n: "builder_ui.prop_type.styles.align_items_types.stretch",
      value: "stretch",
    },
    {
      label: "Baseline",
      labelI18n: "builder_ui.prop_type.styles.align_items_types.baseline",
      value: "baseline",
    },
  ],
} as const;
